import React, { useState } from "react";
import {
  Card,
  DataTable,
  Button,
  Modal,
  Text,
  Thumbnail,
} from "@shopify/polaris";
import { PAGE_SIZE } from "../../constants/common-constants";

const SupportTicketsTable = ({ tickets, currentPage, setCurrentPage }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const openImageInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  function capitalizeEachWord(str) {
    return str
      ?.split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  const handleCloseModal = async () => {
    setModalOpen(false);
    setSelectedTicket(false);
  };

  function truncateString(inputString) {
    const WORD_LIMIT = 3;
    const words = inputString.split(" ");
    if (words.length <= WORD_LIMIT) {
      return inputString;
    }
    return words.slice(0, WORD_LIMIT).join(" ") + " ...";
  }
  const rows = tickets.map((ticket) => [
    truncateString(ticket.subject),
    capitalizeEachWord(ticket?.priority),
    capitalizeEachWord(ticket?.contactName),
    capitalizeEachWord(ticket?.status),

    new Date(ticket.createdAt).toDateString(),

    <Button
      onClick={() => {
        setSelectedTicket(ticket);
        setModalOpen(true);
      }}
    >
      View
    </Button>,
  ]);

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={["text", "text", "text", "text", "text"]}
        headings={[
          <Text variant="headingSm">Subject</Text>,
          <Text variant="headingSm"> Priority</Text>,
          <Text variant="headingSm"> Contact Name</Text>,
          <Text variant="headingSm"> Status</Text>,
          <Text variant="headingSm">Created On</Text>,
          <Text variant="headingSm">Action </Text>,
        ]}
        rows={rows}
        pagination={{
          hasNext: tickets?.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
      />
      {modalOpen && selectedTicket && (
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          title={"Query Details"}
          secondaryActions={[
            {
              content: "Cancel",
              onAction: handleCloseModal,
            },
          ]}
        >
          <Modal.Section>
            <Text variant="headingSm">Subject : {selectedTicket.subject}</Text>
            <br />
            <Text variant="bodySm"> Query : {selectedTicket.query}</Text>
            <br />
            {selectedTicket.attachment && (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  openImageInNewTab(selectedTicket.attachment);
                }}
              >
                <Thumbnail source={selectedTicket.attachment} size="large" />
              </div>
            )}
          </Modal.Section>
        </Modal>
      )}
    </Card>
  );
};

export default SupportTicketsTable;
